export const KeyThemeLocalstorage: string = 'theme'
